import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

export default () => {
  const classes = useStyles();
  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 175 171"
    >
      <path
        fill="#333333"
        d="M87.284 0.218903C38.8349 0.218903 0 35.9222 0 85.1486C0 134.375 38.8349 170.837 87.284 170.837C135.733 170.837 174.883 134.817 174.883 85.3066C174.883 35.7959 135.733 0.218903 87.284 0.218903Z"
      />
      <path
        fill="#ffffff"
        d="M134.472 75.1009C134.472 71.6254 134.472 68.371 134.472 65.4642C134.472 47.1702 125.709 38.0074 118.364 33.584C110.865 29.3474 102.384 27.1678 93.777 27.2648C75.5889 27.2648 62.2552 32.3833 53.8704 42.5256C49.0695 48.5052 46.1704 55.792 45.5486 63.4421V64.0424C45.7704 66.4948 46.9056 68.7735 48.7281 70.4247C50.5507 72.0759 52.9269 72.9784 55.3834 72.9524C57.6948 73.183 60.0067 72.5198 61.8465 71.0986C63.6863 69.6773 64.9149 67.6053 65.2813 65.3062C67.3932 55.4483 72.09 46.3487 92.0748 46.3487C102.698 46.3487 109.633 48.5288 113.258 53.047C114.537 54.425 115.502 56.066 116.084 57.8558C116.667 59.6456 116.853 61.5412 116.63 63.4105C116.63 66.7596 115.369 70.8987 105.566 72.8892C99.0842 74.1913 92.5402 75.1615 85.9596 75.7961L82.8074 76.1752C45.8954 80.5354 40.379 99.9669 40.379 111.183C40.379 131.531 64.7769 143.032 82.3976 143.506H85.5498C92.2044 143.668 98.8251 142.509 105.03 140.094L105.566 139.872C111.664 137.547 117.19 133.93 121.765 129.268C126.34 124.605 129.857 119.008 132.076 112.858C134.976 105.149 134.724 89.1927 134.472 75.1009ZM115.716 95.7962C115.716 119.114 93.3672 124.233 84.7618 124.233C73.0357 124.233 60.3954 117.913 60.3954 107.834C60.3954 96.9021 70.1672 93.4897 90.7824 90.3302C96.1096 89.5087 104.841 87.9921 110.641 86.8546C112.384 86.4966 114.085 85.9566 115.716 85.2432V95.7962Z"
      />
    </svg>
  );
};
